import type { CustomFilterConfig } from 'hooks/useDirectoryData/types';

import { sortOptionsByLabel } from '../helpers/sortOptionsByLabel';
import CustomCheckboxFilter from './CustomCheckboxFilter';
import CustomDropdownFilter from './CustomDropdownFilter';

export interface CustomFiltersProps {
  filters: CustomFilterConfig[];
  values: Record<string, string[]>;
  onChange: (filterId: string, selected: string[]) => void;
  locale: string;
  variant: 'checkbox' | 'inline' | 'dropdown';
}

function getVariant(filter: CustomFilterConfig, variant: 'checkbox' | 'inline' | 'dropdown'): 'dropdown' | 'checkbox' {
  if (variant === 'inline') return 'dropdown';
  return filter.variant ?? variant;
}

function CustomFilters({ filters, values, onChange, locale, variant }: CustomFiltersProps) {
  return (
    <div className="customFilters">
      {filters.map((filter) => {
        const sortedFilter = sortOptionsByLabel(filter, locale);
        const selected = values[filter.id] ?? [];
        const resolvedVariant = getVariant(filter, variant);
        const handleChange = (newSelected: string[]) => {
          onChange(filter.id, newSelected);
        };

        return (
          <div key={filter.id} className="customFilters__group">
            {resolvedVariant === 'checkbox' && (
              <CustomCheckboxFilter filter={sortedFilter} selected={selected} locale={locale} onChange={handleChange} />
            )}
            {resolvedVariant === 'dropdown' && (
              <CustomDropdownFilter filter={sortedFilter} selected={selected} locale={locale} onChange={handleChange} />
            )}
          </div>
        );
      })}
    </div>
  );
}

export default CustomFilters;
